import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import { useTheme } from "@mui/material/styles";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function ComplexStatisticsCard({ color = "info", title, count, percentage, icon }) {
  const theme = useTheme();

  return (
    <Card
      sx={{
        backgroundColor: theme.palette.mode === "dark" ? "#2c2c2c" : "#ffffff",
        borderRadius: "16px",
        boxShadow:
          theme.palette.mode === "dark"
            ? "0 0 10px rgba(0,0,0,0.4)"
            : "0 4px 12px rgba(0,0,0,0.08)",
        padding: 2,
        transition: "all 0.3s ease-in-out",
      }}
    >
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDBox lineHeight={1}>
          <MDTypography variant="button" fontWeight="light" color="text" textTransform="capitalize">
            {title}
          </MDTypography>
          <MDTypography variant="h5" fontWeight="bold">
            {count}
          </MDTypography>
        </MDBox>

        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="3rem"
          height="3rem"
          borderRadius="xl"
          sx={{
            background: theme.palette[color]?.main || theme.palette.info.main,
            color: theme.palette[color]?.contrastText || "#fff",
          }}
        >
          <Icon fontSize="default">{icon}</Icon>
        </MDBox>
      </MDBox>

      {percentage && (
        <MDBox mt={2} mb={0} lineHeight={1}>
          <MDTypography variant="caption" color={percentage.color || "text"} fontWeight="light">
            {percentage.label}
          </MDTypography>
        </MDBox>
      )}
    </Card>
  );
}

// Typechecking props
ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "text",
      "light",
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.string.isRequired,
};

export default ComplexStatisticsCard;
